import * as MuiTextField from '@mui/material/TextField'
import React, { RefObject } from 'react'

export type TextFieldProps = MuiTextField.TextFieldProps

export const TextField = React.forwardRef(
  (
    { children, ...props }: TextFieldProps,
    ref:
      | ((instance: HTMLDivElement | null) => void)
      | RefObject<HTMLDivElement>
      | null
      | undefined,
  ) => (
    <MuiTextField.default ref={ref} {...props}>
      {children}
    </MuiTextField.default>
  ),
)
